import {INK_COLORS} from '~/constants/InkConstants';

export const DEFAULT_STYLE_ID = '116200';
export const DEFAULT_COLOR_ID = '116200';
export const DEFAULT_CATEGORY_PATH = '/t-shirts/short-sleeve-t-shirts/16';
export const DEFAULT_SIZES = [
  'YXS',
  'YS',
  'YM',
  'YL',
  'YXL',
  'S',
  'M',
  'L',
  'XL',
  'XXL',
  'XXXL',
  'XXXXL'
];

export const CORE_SIZES = [
  'S',
  'M',
  'L',
  'XL',
  'SM',
  'LG',
  'S/M',
  'M/L',
  'L/XL',
  'Adult',
  'One Size'
];

export const DEFAULT_VIEWS = ['front', 'back'];
export const DEFAULT_VIEW_IDS = [1, 3];
export const SLEEVE_VIEW_IDS = [4, 5];
export const YOUTH_SIZE = 'YOUTH';
export const ADULT_SIZE = 'ADULT';
export const SLEEVE_COLOR_LIMIT = 8;
export const EXTENDED_NOTE_LENGTH = 40;
export const DEFAULT_MAXIMUM_PRODUCT_COUNT = 30;
export const DESKTOP_IMAGE_WIDTH = 1000;
export const MOBILE_IMAGE_WIDTH = 600;
export const NOTE_AUTO_TOGGLE_DURATION = 5000;
export const VIEW_ID_MAP = {
  front: 1,
  back: 3,
  rightSleeve: 5,
  leftSleeve: 4
};
export const ID_VIEW_MAP = {
  1: 'front',
  3: 'back',
  5: 'rightSleeve',
  4: 'leftSleeve'
};

export const VIEW_DISPLAY_NAME_MAP = Object.freeze({
  1: 'front',
  3: 'back',
  5: 'right sleeve',
  4: 'left sleeve'
});

export const ALT_IMAGERY_BLACKLIST = [
  '288000',
  '262700',
  '288600',
  '289000',
  '168500',
  '244800',
  '240500',
  '240200',
  '229200',
  '229400',
  '226400',
  '227800',
  '239800',
  '199400',
  '168200'
].reduce((o, id) => {
  o[id] = true;
  return o;
}, {});

export const HANES_TAGLESS = {
  styleId: '116200',
  colorId: '116200',
  categoryPath: '/t-shirts/short-sleeve-t-shirts/16',
  flagName: 'hanes'
};

export const HANES_ESSENTIAL = {
  styleId: '297300',
  colorId: '297300',
  categoryPath: '/t-shirts/short-sleeve-t-shirts/16',
  flagName: 'hanesEssential'
};

const GILDAN_SOFTSTYLE = {
  styleId: '176100',
  colorId: '176100',
  categoryPath: '/t-shirts/short-sleeve-t-shirts/16',
  flagName: 'gildanSoftstyle'
};

export const DEFAULT_BLANK_PRODUCT = GILDAN_SOFTSTYLE;

export const DEFAULT_TOO_MANY_PRODUCTS_ERROR_MESSAGE = `If you'd like to order more than ${DEFAULT_MAXIMUM_PRODUCT_COUNT} different items, a member of our team can help you out.`;

export const DOOR_OPENER_CATEGORY_ID = 566;

export const MASKS_CATEGORY_ID = 205;

export const EXEMPT_BLANK_MASK_IDS = [845800, 864200, 864300];

export const LASER_ENGRAVED_COLOR = INK_COLORS.Gray;

export const DecorationMethod = Object.freeze({
  ScreenPrint: 'screen',
  Embroidery: 'embroidery',
  LaserEngraving: 'laser engraving'
});

export const DECORATION_METHOD_DISPLAY_NAME = Object.freeze({
  [DecorationMethod.ScreenPrint]: 'Printing',
  [DecorationMethod.Embroidery]: 'Embroidery',
  [DecorationMethod.LaserEngraving]: 'Laser Engraving'
});

export const STYLE_TYPE = Object.freeze({
  APPAREL: 'apparel',
  NON_APPAREL: 'non-apparel'
});

export const MULTI_ITEM_STYLE_OVERRIDES = [];

export const APPAREL_RESIZING = {
  CONSTRAINT_RATIO: 0.8, // 80% of the constraint
  TOP_OFFSET_INCHES: 1.5 // 1.5 inches
};

export const SUBSEQUENT_UPLOAD_DESIGN_SCALE = 0.6;
export const APPAREL_SMALL_AREA_THRESHOLD = 7;
